module.exports = __webpack_public_path__ + "static/bano-cf2312b1143f679c30ab200a8bce24da.jpg";